import {Component} from "../../../gvf/js/component";
import {ObjectService} from "../../js/object-service";
import Sortable from "sortablejs";

export class CustomObjectInfo extends Component{
    ready(){
        this.$field = this.$root.closest(".js-form-field-custom-object");
        this.findMember(["edit","view"]).click(
            (ev)=>{
                ev.preventDefault();
                const $item = $(ev.currentTarget).closest(this.scope+"__item");
                const data = $item.data("data");
                const index = $item.prevAll(this.scope+"__item").length;
                this.$field.openModal(data,index);
            }
        );
        this.findMember(["edit-ref","view-ref"]).click(
            (ev)=>{
                ev.preventDefault();
                const $item = $(ev.currentTarget).closest(this.scope+"__item");
                const data = $item.data("data");
                const service = new ObjectService("WorkerLibraryItem");
                service.openDetailModal(
                    {
                        objectId:data.ref.id,
                        editMode:$(ev.currentTarget).is(this.scope+"__edit-ref"),
                        saveCallback:()=>{
                            this.$field.formFieldSetVal(this.$field.formFieldVal());
                        },
                        data:this.$field.data()
                    }
                );
            }
        );
        this.findMember("clone").click(
            (ev)=>{
                ev.preventDefault();
                const $item = $(ev.currentTarget).closest(this.scope+"__item");
                const data = $item.data("data");
                this.$field.openModal(data);
            }
        );
        this.findMember("copy").click(
            (ev)=>{
                ev.preventDefault();
                const $item = $(ev.currentTarget).closest(this.scope+"__item");
                const index = $item.prevAll(this.scope+"__item").length;
                this.$field.copyValue(index);
            }
        );
        this.findMember("remove").click(
            (ev)=>{
                ev.preventDefault();
                const $item = $(ev.currentTarget).closest(this.scope+"__item");
                const index = $item.prevAll(this.scope+"__item").length;
                this.$field.removeItem(index);
                $item.remove();
            }
        );

        if(this.$field.data("sortable")){
            new Sortable(
                this.$root.get(0),
                {
                    onEnd: (ev)=>{
                        const fieldValue = this.$field.formFieldVal();
                        if($.isArray(fieldValue)){
                            const value = fieldValue.splice(ev.oldIndex,1)[0];
                            fieldValue.splice(ev.newIndex,0,value);
                            this.$field.formFieldSetVal(fieldValue);
                        }
                    }
                }
            );
        }
    }       
}
